import { render, staticRenderFns } from "./specialized.vue?vue&type=template&id=744f87d1&scoped=true"
import script from "./specialized.vue?vue&type=script&lang=js"
export * from "./specialized.vue?vue&type=script&lang=js"
import style0 from "./specialized.vue?vue&type=style&index=0&id=744f87d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f87d1",
  null
  
)

export default component.exports